import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogActions } from 'src/app/model/dictionary';

export enum ConfirmAnalysisDialogMode {
  LowCredits = 'lowCredits',
  InsufficientCredits = 'insufficientCredits',
  NoCredits = 'noCredits',
}

export interface ConfirmAnalysisDialogData {
  analysisTypeLabel: string;
  cost: number;
  availableCredits: number;
  mode: ConfirmAnalysisDialogMode;
}

@Component({
  selector: 'app-confirm-analysis-dialog',
  templateUrl: './confirm-analysis-dialog.component.html',
  styleUrls: ['./confirm-analysis-dialog.component.scss']
})
export class ConfirmAnalysisDialogComponent {

  readonly Mode = ConfirmAnalysisDialogMode;

  constructor(
    private dialogRef: MatDialogRef<ConfirmAnalysisDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmAnalysisDialogData
  ) {}

  get canConfirm(): boolean {
    return this.data.mode === ConfirmAnalysisDialogMode.LowCredits;
  }

  get titleKey(): string {
    switch (this.data.mode) {
      case ConfirmAnalysisDialogMode.NoCredits:
        return 'confirmAnalysisDialog.noCredits.title';
      case ConfirmAnalysisDialogMode.InsufficientCredits:
        return 'warnings.insufficientCredits';
      case ConfirmAnalysisDialogMode.LowCredits:
        return 'confirmAnalysisDialog.lowCredits.title';
    }
  }

  get messageKey(): string | undefined  {
    switch (this.data.mode) {
      case ConfirmAnalysisDialogMode.NoCredits:
        return 'confirmAnalysisDialog.noCredits.message';
      case ConfirmAnalysisDialogMode.LowCredits:
        return 'warnings.analysisCost';
    }
  }

  get iconName(): string {
    switch (this.data.mode) {
      case ConfirmAnalysisDialogMode.NoCredits:
      case ConfirmAnalysisDialogMode.InsufficientCredits:
        return 'error';
      case ConfirmAnalysisDialogMode.LowCredits:
        return 'warning';
    }
  }

  doConfirm() {
    this.dialogRef.close({ event: DialogActions.CONFIRM });
  }

  doDecline() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
